import { IDebtorCategories } from '@common/interfaces/bbc'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  debtorCategories: createLoadingDataReducer<IDebtorCategories>([
    actions.GET_DEBTOR_CATEGORIES_REQUEST,
  ]),
})
